<script setup>
  import Image from '@components/Image.vue'

  defineProps({
    article: Object
  })
</script>
<template>
  <div class="item">
    <a :href="article.path">
      <div class="left col-5 col-sm-12">
        <div class="photo">
          <Image :image="article.thumbnail" />
        </div>
      </div>
      <div class="right col-7 col-sm-12">
        <h3>{{ article.title }}</h3>
        <p class="date">{{ article.created_at }}</p>
      </div>
    </a>
  </div>
</template>
